import { memo } from 'react';
import { useField } from 'formik';

import { FormBlock } from 'types';

import { BlockItemProps } from './types';
import { SortableBlockAccordion } from './sortable-block-accordion';

export const BlockItem = memo(
  ({ index, blocksName, ...rest }: BlockItemProps) => {
    const [, { value: block }] = useField<FormBlock | undefined>(
      `${blocksName}.${index}`
    );
    if (!block) return null;
    return (
      <SortableBlockAccordion
        block={block}
        index={index}
        blocksName={blocksName}
        {...rest}
      />
    );
  }
);

BlockItem.displayName = 'BlockItem';
